import { css } from "@emotion/react";

export type FormValues = Record<string, unknown>;

export type TestAttribute = {
  dataTest?: string;
};

export const stackedLabelCss = css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
